import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import API_BASE_URL from '../api';

const FrontPage = () => {
  const [name, setName] = useState(
    () => localStorage.getItem('name') || '', // initial value
  );

  const getAuthToken = () => {
    return localStorage.getItem('stack_access_token');
  };

  useEffect(() => {
    const token = getAuthToken();
    console.log('[FrontPage] token on mount:', token);

    if (!token) {
      console.warn('No auth token found, using localStorage name only');
      const storedName = localStorage.getItem('name') || '';
      setName(storedName);
      return;
    }

    fetch(`${API_BASE_URL}/api/profile/`, {
      headers: {
        'Content-Type': 'application/json',
        'X-Stack-Access-Token': token, // matches authenticateToken
      },
    })
      .then((response) => {
        if (!response.ok) {
          console.error('Profile fetch failed with status:', response.status);
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then((data) => {
        console.log('[FrontPage] /profile data:', data);
        if (data && data.name) {
          setName(data.name);
        } else {
          const storedName = localStorage.getItem('name') || '';
          setName(storedName);
        }
      })
      .catch((error) => {
        console.error('Failed to fetch name:', error);
        const storedName = localStorage.getItem('name') || '';
        setName(storedName);
      });
  }, []);

  return (
    <div
      className="flex flex-col justify-between min-h-screen"
      style={{ backgroundColor: '#0D2329' }}
    >
      <Navbar />
      <main className="flex flex-col flex-grow items-center justify-center px-6 py-24 sm:py-32 lg:px-8">
        <div className="text-center">
          <p className="mt-6 text-3xl leading-7 text-white">Hello {name}!</p>
          <p className="mt-6 text-xl leading-7 text-white">Welcome to</p>
          <img
            className="col-span-40 max-h-40 w-full object-contain lg:col-span-1"
            src="logo_bigger.png"
            alt="logo"
          />
          <p className="mt-6 text-xl leading-7 text-white">
            Complete your profile so that you can begin your dating journey.
          </p>
          <div className="mt-10 flex items-center justify-center gap-x-6">
            <a
              href="/age-info"
              style={{
                backgroundColor: '#05664f',
                color: 'white',
                textDecoration: 'none',
                padding: '10px 15px',
                borderRadius: '5px',
                display: 'inline-block',
                width: '120px',
                textAlign: 'center',
              }}
            >
              Begin
            </a>
          </div>
        </div>
      </main>
    </div>
  );
};

export default FrontPage;
